

import { showErrorAxios } from "infra/helpers/alerta";
import http from "infra/http";
import { useMutation, useQueryClient } from "react-query";
import { AdicionarContaForm } from "../typings";

interface UseRemoverContaRateioProps {
  id?: string;
  year: string;
  month: string;
}
function useRemoverContaRateio({id, year, month}: UseRemoverContaRateioProps) {
  const queryClient = useQueryClient();

  return useMutation(
    "remover-contas/v1/rateio",
    ({ data }: { data: AdicionarContaForm }) =>
      http.delete(`/v1/rateio/${id}/${year}/${month}/contas`, {
        data
      }),
    {
      retry: false,
      onSuccess: () => {
        queryClient.invalidateQueries(`/v1/rateio/${id}/${year}/${month}/contas`);
      },
      onError: (e) => {
        showErrorAxios(e)
      }
    }
  );
}

export default useRemoverContaRateio;
